import React, { useMemo } from 'react';
import { Button } from '@mui/material';
import ScalarSpreadsheet from 'components/ScalarSpreadsheet';
import { ValueEditor } from 'components/Spreadsheet/components';
import { useKpiActions } from 'pages/Financials/kpi/utils';
import { KpiTableProps } from './KpiTable.props';

const KpiTable = (props: KpiTableProps) => {
  const { kpiSheet, sharedProps, setTableData, isDisabled, ...rest } = props;
  const { workbook } = sharedProps;

  const companyKPIsExist = useMemo(() => kpiSheet.tableData?.companyKPIs?.length > 0, [kpiSheet.tableData]);
  const { onAddKPI, onDeleteKPI, onChangeDataType } = useKpiActions(kpiSheet, workbook);

  return (
    <>
      {companyKPIsExist ? (
        // @ts-expect-error: ScalarSpreadsheet is not typed
        <ScalarSpreadsheet
          {...kpiSheet}
          {...rest}
          {...sharedProps}
          sheet={kpiSheet}
          deleteRowFn={onDeleteKPI}
          allowChangeDataType
          changeRowDataTypeFn={onChangeDataType}
          editorForTitles={ValueEditor as any}
        />
      ) : (
        <h3 style={{ marginLeft: '1rem' }}>KPI Table</h3>
      )}

      <Button
        variant="outlined"
        color="primary"
        onClick={onAddKPI}
        style={{ marginTop: '1rem', marginLeft: '1rem' }}
        disabled={isDisabled}>
        ADD KPI ROW
      </Button>
    </>
  );
};

export default KpiTable;
